module.exports = __webpack_public_path__ + "static/erweima-order-installment.de5f7f12.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/erweima-order-installment.png
// module id = 971
// module chunks = 2